import { mount } from "@vue/test-utils";
import SectionLabel from "@/components/core/SectionLabel";

describe("SectionLabel test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(SectionLabel);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component SectionLabel", () => {
    expect(wrapper).toBeDefined();
  });
});
